import { Box, Drawer, useTheme } from '@mui/material';
import * as Preact from 'preact';
import { RETURN_TO_STORE_HEIGHT } from './M_ReturnToStoreBanner';
import * as ModalActionBar from './O_Modal/M_ModalActionBar';
import * as ModalTitle from './O_Modal/M_ModalTitle';
import { isSmallScreen } from './domain/theme/breakpoints';
export var Component = function (p) {
    var theme = useTheme();
    return isSmallScreen(useTheme()) ? (Preact.h(Drawer, { anchor: 'bottom', open: p.open, PaperProps: { sx: { borderRadius: '10px 10px 0px 0px' } }, onClose: p.onCloseClick, sx: { maxHeight: "calc(100% - ".concat(RETURN_TO_STORE_HEIGHT, ")"), height: 'max-content' } },
        Preact.h(ModalTitle.Component, { title: p.title, onCloseClick: p.onCloseClick }),
        p.children,
        p.actionBar && (Preact.h(ModalActionBar.Component, { primary: p.actionBar.primary, secondary: p.actionBar.secondary })))) : (Preact.h(Preact.Fragment, null,
        Preact.h(Box, { zIndex: theme.zIndex.appBar - 1, height: "100%", width: "calc(100% - 72px)", position: "fixed", sx: { opacity: 0 }, display: p.open ? '' : 'none', onClick: p.onCloseClick }),
        Preact.h(Box, { minWidth: "302px", borderRadius: "10px", overflow: "hidden", bgcolor: "background.paper", position: "absolute", zIndex: "modal", display: p.open ? '' : 'none', sx: p.sx },
            Preact.h(ModalTitle.Component, { title: p.title, onCloseClick: p.onCloseClick }),
            p.children,
            p.actionBar && (Preact.h(ModalActionBar.Component, { primary: p.actionBar.primary, secondary: p.actionBar.secondary })))));
};
Component.displayName = 'ActionBarModal';
